import React from "react";
import Breadcumb from "../components/ProductDescription/Breadcumb";
import Detail from "../components/ProductDescription/Detail";
import Header from "../components/HomePage/Header";
import Footer from "../components/HomePage/Footer";
import styled from "styled-components";
import ScrollPromices from "../components/HomePage/ScrollPromices";
import OurBrands from "../components/HomePage/OurBrands";
import Promotions from "../components/HomePage/Promotions/Promotions";
import BottomPromises from "../components/HomePage/BottomPromises";
import PopularSearch from "../components/HomePage/PopularSearch";
import { useMediaQuery } from "react-responsive";
import MobileHeader from "../mobileComponent/MobileEndpoints/MobileHeader";
import MobileFooter from "../mobileComponent/MobileEndpoints/MobileFooter";
import MobilePromotion from "../mobileComponent/MobileHomePage/MobilePromotion/MobilePromotion";
import MobileDetails from "../mobileComponent/MobileDescriptionPage/MobileDetails";

function ProductDescription() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 501px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 500px)" });
  return (
    <div>
      {isDesktopOrLaptop && (
        <>
          <HeaderDiv>
            <ScrollPromices />
            <Header />
          </HeaderDiv>
          <RestPart>
            <Breadcumb />
            <Detail />
            <Promotions />
            <OurBrands />
            <BottomPromises />
            <PopularSearch />
            <Footer />
          </RestPart>
        </>
      )}
      {isTabletOrMobile && (
        <>
          <MobileHeaderDiv>
            <MobileHeader />
          </MobileHeaderDiv>
          <MobileDetails />
          <MobilePromotion />
          <MobileFooter />
        </>
      )}
    </div>
  );
}

export default ProductDescription;

const HeaderDiv = styled.div`
  width: 100%;
  height: 80px;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

const RestPart = styled.div`
  position: relative;
  top: 30px;
  @media (max-width: 500px) {
    position: relative;
    top: 30px;
  }
`;

const MobileHeaderDiv = styled.div`
  width: 100%;
  height: auto;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
`;
